// extracted by mini-css-extract-plugin
export default {"cartItemDetails":"cartItemDetails__OWYwZ","smaller":"smaller__ODZlM"};